// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","secondary":"Button_secondary__sUGsj","pink":"Button_pink__dc1pM","outlined":"Button_outlined__-tAZi"};